/**
 * AddMarketForm.js
 * 版本：V1.01 | 更新日期：2025-07-16 15:35:00
 * 功能：市場新增表單組件，提供動態新增市場功能
 * 關連檔案：BookingModal.js, Firebase 資料庫
 */

import React, { useState } from 'react';
import { serverTimestamp } from 'firebase/firestore';
import { logMarketOperation } from '../MarketOperationLogs/marketOperationLogService';
import { getRegionByCity } from '../../utils/regionUtils';
import { createUniqueMarket } from '../../utils/marketUtils';

const AddMarketForm = ({ selectedCity, db, onMarketAdded, appId, currentUser, markets }) => {
    const [newMarketName, setNewMarketName] = useState('');
    const [isSaving, setIsSaving] = useState(false);
    const handleAddNewMarket = async () => {
        if (!newMarketName.trim()) {
            alert('新市場名稱不可為空！');
            return;
        }
        setIsSaving(true);
        try {
            const region = getRegionByCity(selectedCity);
            if (!region) {
                alert(`無法判斷「${selectedCity}」的所屬區域！`);
                return;
            }
            const marketData = {
                city: selectedCity,
                name: newMarketName.trim(),
                region,
                regionUpdatedAt: serverTimestamp()
            };
            const result = await createUniqueMarket({ db, appId, markets, marketData });
            if (!result.created) {
                alert(`「${result.market.name}」已存在於${result.market.city}，不能重複新增。`);
                onMarketAdded(result.market.id);
                return;
            }
            // 【AI承諾】新增市場時記錄操作紀錄，方便稽核
            await logMarketOperation(db, appId, 'add', result.market, currentUser);
            setNewMarketName('');
            onMarketAdded(result.market.id);
        } catch (err) {
            alert("新增市場失敗：" + err.message);
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <div className="p-3 bg-gray-100 rounded-lg space-y-2">
            <label className="block text-md font-medium text-gray-700">
                在「{selectedCity}」新增市場
            </label>
            <div className="flex gap-2">
                <input
                    type="text"
                    value={newMarketName}
                    onChange={e => setNewMarketName(e.target.value)}
                    placeholder="輸入新市場的名稱"
                    className="w-full p-2 border rounded-lg"
                />
                <button 
                    type="button" 
                    onClick={handleAddNewMarket} 
                    disabled={isSaving} 
                    className="bg-green-500 text-white font-semibold px-4 py-2 rounded-lg whitespace-nowrap"
                >
                    {isSaving ? '...' : '儲存'}
                </button>
            </div>
        </div>
    );
};

export default AddMarketForm;
